module.exports = __webpack_public_path__ + "static/media/ic_tick.7cf8d9ad.svg";